import React from 'react';
import glamorous from 'glamorous';
import { Card } from '@blueprintjs/core';
import { isEmpty } from 'lodash';

const StyledCard = glamorous(Card)({
  padding: '3px !important',
});

const ImgWithSource = ({ src, source, title }) => {
  return (
    <StyledCard elevation={3}>
      {!isEmpty(title) && title}
      <glamorous.Div css={{ textAlign: 'center' }}>
        <glamorous.Img src={src} css={{ maxWidth: '100%' }}/>
      </glamorous.Div>
      {!isEmpty(source) &&
      <glamorous.Div css={{ textAlign: 'center' }}>
        <i>
          Source: <a href={source} target="_blank">{source}</a>
        </i>
      </glamorous.Div>}
    </StyledCard>
  );
};

export default ImgWithSource;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/img-with-source.js